/**
 * Terceira coluna do ultrawide (≥ 1900 px): relógio, serviços e família.
 *
 * "Integração PharuCut" do design saiu: não há como checar o Cut sem login,
 * e um "operacional" sem checagem seria mentira na tela.
 */
import React, { useEffect, useState } from "react";

import { classeDoPonto } from "./PilulaStatus";
import { STATUS_FALHA, STATUS_OK } from "./useStatusDoServidor";
import { IconeCaixa, IconeTesoura, SimboloPharu } from "./icones";

const MINUTO_MS = 60 * 1000;
const COR_PHARUCUT = "#8b8cff";
const COR_PHARU_3D = "#f0b35a";
const COR_PHARU_ERP = "#38bdf8";

function formatarData(data) {
  try {
    return new Intl.DateTimeFormat("pt-BR", { weekday: "long", day: "2-digit", month: "long" }).format(data);
  } catch {
    return data.toDateString();
  }
}

/** Re-renderiza só quando o minuto vira (o relógio não mostra segundos). */
function useMinutoAtual() {
  const [minuto, setMinuto] = useState(() => Math.floor(Date.now() / MINUTO_MS));
  useEffect(() => {
    const id = window.setInterval(() => setMinuto(Math.floor(Date.now() / MINUTO_MS)), 1000);
    return () => window.clearInterval(id);
  }, []);
  return minuto;
}

function Relogio() {
  const data = new Date(useMinutoAtual() * MINUTO_MS);
  return (
    <div className="xc">
      <div className="kicker">Agora</div>
      <div className="clk">
        {String(data.getHours()).padStart(2, "0")}
        <span>:</span>
        {String(data.getMinutes()).padStart(2, "0")}
      </div>
      <div className="xd">{formatarData(data)}</div>
    </div>
  );
}

function rotuloDoServico(status) {
  if (status === STATUS_OK) return "operacional";
  if (status === STATUS_FALHA) return "sem conexão";
  return "verificando";
}

function Servicos({ status }) {
  return (
    <div className="xc">
      <div className="kicker">Serviços</div>
      <div style={{ marginTop: 8 }}>
        <div className="xr">
          <span className={classeDoPonto(status)} aria-hidden="true" />
          <span>Pharu ERP</span>
          <span className="xm">{rotuloDoServico(status)}</span>
        </div>
      </div>
    </div>
  );
}

function Familia({ marca }) {
  return (
    <div className="xc grow">
      <div className="kicker">Família Pharu</div>
      <div style={{ marginTop: 8 }}>
        <div className="fam-i">
          <span className="fam-m">
            <SimboloPharu tamanho={18} cor={COR_PHARU_ERP} />
          </span>
          <div>
            <div className="fam-t">Pharu ERP</div>
            <div className="fam-d">Gestão da marcenaria</div>
          </div>
          {!marca.ehPainel && <span className="here">Você está aqui</span>}
        </div>
        <div className="fam-i">
          <span className="fam-m" style={{ color: COR_PHARUCUT }}>
            <IconeTesoura />
          </span>
          <div>
            <div className="fam-t">PharuCut</div>
            <div className="fam-d">Planos de corte otimizados</div>
          </div>
        </div>
        <div className="fam-i">
          <span className="fam-m" style={{ color: COR_PHARU_3D }}>
            <IconeCaixa />
          </span>
          <div>
            <div className="fam-t">Pharu 3D</div>
            <div className="fam-d">Projetos em 3D</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function PainelUltrawide({ marca, status }) {
  return (
    <aside className="e-x" aria-label="Status e família Pharu">
      <Relogio />
      <Servicos status={status} />
      <Familia marca={marca} />
    </aside>
  );
}
